import { consoleApiSlice } from "./consoleApiSlice";

export const imagesApiSlice = consoleApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadImage: builder.mutation({
      query: (arg) => {
        // Handle both simple file input and {file} object
        const file = arg.file || arg;
        const formData = new FormData();
        formData.append("image", file);
        return {
          url: "image/upload-image",
          method: "POST",
          body: formData,
          formData: true,
        };
      },
    }),
    getPresignedUrls: builder.mutation({
      query: (imageUrls) => ({
        url: "image/presigned-urls",
        method: "POST",
        body: {
          image_urls: imageUrls,
        },
      }),
    }),
  }),
});

export const { useUploadImageMutation, useGetPresignedUrlsMutation } = imagesApiSlice;
